import React from 'react';

const Footer = () => {
  return (
    <footer
      className="border-top pt-5 pb-4"
      style={{ backgroundColor: 'var(--color-surface)' }}
    >
      <div className="container">
        <div className="row gy-5">

          {/* BRAND */}
          <div className="col-12 col-md-6 col-lg-4">
            <h4
              className="fw-bold"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Hindustan Fruits & Veg Pvt Ltd
              <span style={{ color: 'var(--color-success)' }}>.</span>
            </h4>

            <p
              className="mt-3"
              style={{ color: 'var(--color-text-secondary)' }}
            >
              Premium Indian fruit supply · Wholesale · Export · Family owned
            </p>

            <p className="small mb-1" style={{ color: 'var(--color-text-secondary)' }}>
              <i className="bi bi-geo-alt me-2" />
              Shop No:11, Bazar Samiti Yard Sandha Chapra – 841301 
               

            </p>

            <p className="small" style={{ color: 'var(--color-text-secondary)' }}>
              <i className="bi bi-building me-2" />
              GST: 27ABCDE1234F1Z5 · IEC: AAHCH9340J
            </p>
          </div>

          {/* PRODUCE */}
          <div className="col-6 col-md-3 col-lg-2">
            <h6
              className="fw-bold text-uppercase mb-3"
              style={{ color: 'var(--color-success)', fontSize: '0.85rem' }}
            >
              Produce
            </h6>
            <ul className="list-unstyled">
              {['Mangoes', 'Oranges', 'Grapes', 'Pomegranate', 'Dragon fruit'].map(
                (item) => (
                  <li key={item} className="mb-2">
                    <a
                      href="#"
                      className="footer-link small text-decoration-none"
                    >
                      {item}
                    </a>
                  </li>
                )
              )}
            </ul>
          </div>

          {/* SECTORS */}
          <div className="col-6 col-md-3 col-lg-2">
            <h6
              className="fw-bold text-uppercase mb-3"
              style={{ color: 'var(--color-success)', fontSize: '0.85rem' }}
            >
              Sectors
            </h6>
            <ul className="list-unstyled">
              {[
                'Wholesale mandi',
                'Retail chains',
                'Food processing',
                'Export / FOB',
                'HoReCa',
              ].map((item) => (
                <li key={item} className="mb-2">
                  <a
                    href="#"
                    className="footer-link small text-decoration-none"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* CERTIFICATIONS */}
          <div className="col-12 col-md-6 col-lg-4">
            <h6
              className="fw-bold text-uppercase mb-3"
              style={{ color: 'var(--color-success)', fontSize: '0.85rem' }}
            >
              Membership & Certifications
            </h6>

            <div className="d-flex flex-wrap gap-2">
              {[
                'FSSAI',
                'APEDA',
                'AGMARK',
                'India Organic',
                'GLOBALG.A.P.',
                'Sedex',
              ].map((badge) => (
                <span
                  key={badge}
                  className="badge border px-3 py-2"
                  style={{
                    backgroundColor: 'var(--color-bg)',
                    color: 'var(--color-text-primary)',
                    fontWeight: 500,
                  }}
                >
                  {badge}
                </span>
              ))}
            </div>

            <p
              className="small mt-4"
              style={{ color: 'var(--color-text-secondary)' }}
            >
              <i className="bi bi-award me-2" />
              Member — Indian Chamber of Food & Agriculture
            </p>
          </div>
        </div>

        <hr className="my-4" />

        {/* BOTTOM BAR */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start gap-3">
          <p
            className="small mb-0"
            style={{ color: 'var(--color-text-secondary)' }}
          >
            © {new Date().getFullYear()} Hindustan Fruits & Veg Pvt Ltd. All rights reserved.
            Prices subject to market fluctuation.
          </p>

          <div className="d-flex gap-4 flex-wrap justify-content-center">
            {['Privacy', 'Terms', 'GST invoice', 'APEDA RCMC'].map((item) => (
              <a
                key={item}
                href="#"
                className="footer-link small text-decoration-none"
              >
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Custom Styling */}
      <style jsx>{`
        .footer-link {
          color: var(--color-text-secondary);
          transition: all 0.3s ease;
        }
        .footer-link:hover {
          color: var(--color-success);
          padding-left: 4px;
        }
      `}</style>
    </footer>
  );
};

export default Footer;
